module.exports = __webpack_public_path__ + "static/img/family.dedac9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/family.jpg
// module id = 237
// module chunks = 6